import "./main.less"
import UI from "./UI.js"

akamai.amp.AMP.registerPlugin("react", ["html", "flash", "external"], UI.create)

export {default as Component} from "./Component.js"
export {default as Container} from "./Container.js"
export {default as ClassList} from "./ClassList.js"
export {default as Panel} from "./Panel.js"
export {default as PanelMenu} from "./PanelMenu.js"
export {default as PanelControl} from "./PanelControl.js"
export {default as ListItem} from "./ListItem.js"
export {default as Mode} from "./Mode.js"

export {UI}
